/**
 * Checks if a route path is valid for post-authentication redirect.
 * Prevents redirect loops back to login, auto-login, error, or reset-password pages.
 */
export const isValidRedirectRoute = (route) => {
  if (!route || typeof route !== "string") return false;
  const pathOnly = route.split("?")[0].split("#")[0];
  const invalidPaths = ["/", "/login", "/autologin", "/error401", "/resetpassword"];
  if (invalidPaths.includes(pathOnly)) return false;
  if (pathOnly.startsWith("/first-time-reset")) return false;
  return true;
};

/**
 * Returns the completed tab redirect URL for group training based on whether
 * the session originated from an admin route or student route.
 */
export const getGroupTrainingCompletedUrl = (location) => {
  const isFromAdmin =
    location?.pathname?.startsWith("/admin") ||
    Boolean(location?.state?.fromAdmin) ||
    sessionStorage.getItem("groupTrainingAdminLaunch") === "true";

  // Clean up session flag immediately once consumed
  sessionStorage.removeItem("groupTrainingAdminLaunch");

  return isFromAdmin
    ? "/admin/credits/group-training?tab=completed"
    : "/user/supervisor-tool/group-training?tab=completed";
};

